module.exports = __webpack_public_path__ + "img/collaborate_46.56912004.jpg";